module.exports = __webpack_public_path__ + "img/levelup_icon_investment.8e78b823.svg";